import { useMutation } from 'react-query';
import axios from 'axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const exportPOsQuery = async (filterData) => {
    return axios.get(`${apiurl?.exportPOs}`, { // your url
        responseType: 'blob',
        params: filterData
    }).then((response) => {
        if (response?.data?.size > 0) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Synergy Kaas Report.xls'); // or any other extension
        document.body.appendChild(link);
        link.click();
        } else {
            showAlert('No data to Export for the selected filter combination', 'error');
        }
    }).catch(() => {
        showAlert('Something went wrong', 'error');
    });
};

const exportPOs = () => {
    return useMutation(['exportPOs'], exportPOsQuery, { refetchOnWindowFocus: false });
};

export default exportPOs;
